/**
 * Config — Chili Piper production values for the bar's Book and Chat
 * experiences (Thryv prod workspace; CP has no staging equivalent for
 * these). CP-admin-owned constants live here; the PHP template only
 * supplies server-derived state (country, phone number, debug, per-page
 * toggles) and can still override any of these through the x-data config
 * argument if a page ever needs to (see Component.data).
 */

var Config = new Object();

/**
 * Book — CP's hosted "Thryv Demo RR" round-robin Scheduling Link (Yuni,
 * 2026-08-03). Loaded in the Book panel iframe on first click; the visitor
 * books entirely inside CP's own hosted UI.
 */
Config.bookingUrl = 'https://thryv.chilipiper.com/round-robin/thryv-demo';

/**
 * Chat — CP Chat widget embed values (CP admin → Flows → Web Experience →
 * Embed tab). The widget renders nothing until a chat journey is
 * PUBLISHED. Opening is native CP: a Custom Trigger on the bar's
 * #thryv-connect-bar-chat button (CP admin → Web Experience → Settings →
 * Custom Triggers) runs the journey; visibility is synced from the
 * widget's state in EventHandlers.watchChatFrame.
 */
Config.chat = {
  workspaceId: '04bb5c2e-5f46-4461-bf9f-936824d0bdbb',
  tenantId: 'thryv',
  chatUrl: 'https://thryv.chilipiper.com/chat/widget/',
  loaderSrc: 'https://thryv.chilipiper.com/chat/embed/assets/index.js',
};

/**
 * 1mind — the "Superhuman" conversational embed behind the AI Advisor
 * button. Deployment ids, the launcher base and the mount id live in
 * src2/1mind/Config.js, which the page-level window.OneMind API also uses;
 * only the bar's own choices are here.
 *
 * env: null means "whatever src2/1mind/Config.js says" (sandbox today,
 * until 1mind confirms the production deployment carries Thryv's persona).
 * The PHP template can override either key through the x-data config.
 */
Config.oneMind = {
  useCase: 'embedded',
  env: null,
  // data-* attributes for page/user context. 1mind's implementation team
  // defines the real names (HubSpot cookie + UTM handoff), so this stays
  // empty until they do.
  attributes: {},
};

/**
 * Presence hours for the online dot on the Chat/Support buttons.
 * null = always online, matching the Call modal's "available 24/7" copy.
 * To gate the dot to business hours instead, set e.g.:
 *   { timeZone: 'America/Chicago', days: [1, 2, 3, 4, 5], open: 8, close: 18 }
 * (days: 0 = Sunday … 6 = Saturday; open/close in that timezone's hours).
 */
Config.hours = null;

export default Config;
